<template>
  <main class="home">
    <header class="header">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/gastos_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary mb-3">
            Monitorea el costo de tu negocio de la forma más sencilla y controla
            a dónde va tu dinero
          </h2>
          <p>
            ContaFácil permite controlar los gastos realizados en tus puntos de
            venta y sus estados de cuenta por pagar. Gestión del costo que
            permite aumentar la retabilidad de tu negocio.
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a class="button is-rounded bg-disabled" @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <tab-modules></tab-modules>
    <section class="section no-padding--left no-padding--right">
      <div class="columns is-desktop section__video no-padding--right">
        <div class="gastos column column-50 column-offset-10 my-4">
          <img class="mal" src="../assets/images/gastos_1.png" alt />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Olvídate de los papeles por todos <br class="is-hidden-touch" />
              lados y administra el costo de tu <br class="is-hidden-touch" />
              negocio de la forma más fácil
            </h3>
            <p>
              No más olvidos en pagar a<br class="is-hidden-touch" />
              proveedores, no más<br class="is-hidden-touch" />
              comprobantes perdidos ni dolores<br class="is-hidden-touch" />
              de cabeza a fin de mes. Simplifica<br class="is-hidden-touch" />
              tu administración del costo y no<br class="is-hidden-touch" />
              tengas sorpresas de los gastos<br class="is-hidden-touch" />
              realizados. Tendrás la información<br class="is-hidden-touch" />
              que necesitas en todo momento.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-ml-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video section__video--column">
        <div class="video-mini column">
          <div class="gastos my-4">
            <img src="../assets/images/gastos_2.png" class="img--center" alt />
          </div>
          <div class="video-mini__text">
            <h3 class="color-primary">
              Monitorea tus compras de inventario y
              <br class="is-hidden-touch" />
              gastos corrientes
            </h3>
            <p>
              Controla los saldos pendientes por pagar a tus<br
                class="is-hidden-touch"
              />
              proveedores y mantén una visión real de los<br
                class="is-hidden-touch"
              />
              gastos efectuados en tu negocio. Genera reportes<br
                class="is-hidden-touch"
              />
              y aclara cualquier duda con tus proveedores.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
    </section>
    <one-view></one-view>
  </main>
</template>

<script>
// @ is an alias to /src
import TabModules from "../components/TabModules";
import OneView from "../components/OneView";
import { EventBus } from "@/event-bus";
export default {
  name: "GastosCompras",
  components: {
    TabModules,
    OneView
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/PYz3wXm5FTI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // height: calc(100vh - 75px);
  // background-image: url("../assets/images/banners/gastos_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  &__content {
    background-color: transparent;
    margin-top: auto;
    // height: 75%;
    width: 100%;
    // padding: 1rem;
    p {
      width: 100%;
    }
  }
  @include tablet() {
    background-image: none;
    // height: fit-content;
    // max-height: 600px;
    // padding: 4em 0;

    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      // padding: 1rem;
      // padding-top: 10rem;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1024px) {
    // height: calc(100vh - 100px);
    // height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/gastos.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 500px;
    &__content-wrap {
      // justify-content: center;
      padding-bottom: 0%;
    }
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    // height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/gastos.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 690px;
  }
  @media (min-width: 1800px) {
    // height: calc(100vh - 120px);
    background-image: url("../assets/images/banners/gastos.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 1230px;
  }
}
.section {
  // padding: 3rem;
  padding-top: 0px;
  .button {
    font-size: 16px;
    font-weight: 500;
  }
  h2 {
    font-weight: bold;
    font-size: 3rem;
  }
  &__video {
    width: 100%;
    margin: 1rem 0px;
    // min-height: 560px;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 4em 0px;
    }
    @include desktop() {
      margin: 7em 0px;
    }
    // min-height: 450px;
    // padding: 2rem;
    .video__text {
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      // order: 2;
      &--right {
        text-align: center;
        align-items: flex-end;
      }
      @media (max-width: 650px) {
        min-width: 100%;
        width: 100%;
      }
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        width: 100%;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        width: 90%;
        font-size: 16px;
        letter-spacing: 0.025em;
        margin: 2em auto;
      }
      .button {
        width: fit-content;
        margin: 1rem auto;
      }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: center;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          width: 90%;
          font-size: 1.5rem;
        }
        .button {
          font-size: 1.2rem;
          // max-width: 200px;
          // margin: 1rem auto;
        }
      }
      @media (min-width: 1024px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
          order: 1;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.2rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.2rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.4rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.4rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          max-width: none;
          margin-top: 1em;
          font-size: 1.2rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-medium() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.5rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.5rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          max-width: none;
          margin-top: 1em;
          font-size: 1.5rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @media (min-width: 1800px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          width: fit-content;
          font-weight: bold;

          font-size: 1.2rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
    }
    .video__player,
    .video-mini__player {
      order: 1;
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include laptop() {
        // order: 0;
      }
    }
    .gastos {
      padding: 0px;
      order: 1;
      img {
        height: auto;
      }
      .img--center {
        max-width: 700px;
        width: 100%;
        margin: 0px;
      }
      @include tablet() {
        display: flex;
        align-items: flex-start;
        img {
          width: 100%;
          object-fit: contain;
        }
      }
      @include laptop() {
        // display: block;
        .img--center {
          max-width: none;
          margin: 3rem auto;
          width: 800px;
        }
        img {
          width: 100%;
        }
      }
      @include desktop() {
        // display: block;
        .img--center {
          max-width: none;
          margin: 3rem auto;
          width: 900px;
        }
        img {
          width: 100%;
        }
      }
      @include desktop-large() {
        // display: block;
        .img--center {
          max-width: none;
          margin: 3rem auto;
          width: 65%;
        }
        img {
          width: 100%;
        }
      }
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 1rem;
      width: 100%;
      h3 {
        letter-spacing: 0.018em;
        font-size: 1.1rem;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        font-size: 1rem;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      @include tablet() {
        width: 100%;
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
        }
        .button {
          // width: 200px;
          font-size: 1.2rem;
          margin: 1rem auto;
        }
      }
      @include laptop() {
        p {
          font-size: 1.4rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
        }
      }
      @include desktop() {
        h3 {
          font-size: 1.4rem;
        }
        p {
          font-size: 1.4rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
        }
      }
      @include desktop() {
        h3 {
          font-size: 1.5rem;
        }
        p {
          font-size: 1.5rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
        }
      }
      @include desktop-large() {
        h3 {
          font-size: 2rem;
        }
        p {
          font-size: 1.8rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          font-size: 1.2rem;
        }
      }
    }
    &:first-child {
      padding-top: 0px;
    }
    &--column {
      width: 75%;
      margin: 3em auto !important;
      flex-flow: column nowrap !important;
      justify-content: flex-start;
      align-items: center;
      h3 {
        font-weight: bold;
        font-size: 1.8rem;
        margin: 2.5em auto 0;
      }
      p {
        margin: 2.5em auto;
      }
      .video__player {
        width: 100%;
        height: 500px;
      }
      @media (max-width: 650px) {
        width: 100% !important;
        h3 {
          letter-spacing: 0.05em;
          font-size: 16px;
          font-weight: bold;
        }
        p {
          font-size: 16px;
          letter-spacing: 0.025em;
        }
      }
      @include tablet() {
        margin: 3em auto !important;
        width: 90%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          line-height: 1.2;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          line-height: 1.2;
          letter-spacing: 0.05em;
          // margin: 2rem auto;
        }
        img {
          width: 95%;
        }
      }
      @include laptop() {
        margin: 8em auto !important;
        width: 100%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          line-height: 1.2;
          font-weight: bold;
        }
        p {
          font-size: 1.2rem;
          line-height: 1.2;
          letter-spacing: 0.05em;
          // margin: 2rem auto;
        }
      }
    }
    @include laptop() {
      margin: 4rem 0;
    }
  }
}
.factura-img {
  display: block;
  width: 500px;
  margin: 4rem auto;
}
</style>
